module.exports = __webpack_public_path__ + "img/addr.87da1c94.png";